import styled from 'styled-components';
import { IonModal, IonPage } from '@ionic/react';

export const DefaultBox = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 0 16px !important;

  @media (min-width: 600px) {
    width: 468px;
    padding: 0 !important;
  }

  @media (min-width: 1024px) {
    width: 960px;
  }
`;

interface DefaultBoxWithNavBarProps {
  isIos: boolean;
  isInternetConnected: boolean;
}

export const DefaultBoxWithNavBar = styled(DefaultBox)<DefaultBoxWithNavBarProps>`
  margin-top: ${(props) =>
    props.isIos ? (props.isInternetConnected ? '108px' : '118px') : props.isInternetConnected ? '64px' : '94px'};
`;

interface DefaultBoxForChoosePsychologistProps {
  isIos: boolean;
  isInternetConnection: boolean;
}

export const DefaultBoxForChoosePsychologist = styled(DefaultBox)<DefaultBoxForChoosePsychologistProps>`
  padding: 1px 16px 16px 16px !important;

  margin-bottom: ${(props) => (props.isIos ? '142px' : '72px')};
  display: grid;
  grid-row-gap: 16px;

  grid-template-columns: 100%;

  .empty-search {
    height: 50vh;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;

    .h3 {
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      text-align: center;
      margin-bottom: 2em;
    }

    .cancel-btn {
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #c13e18;
      padding: 4px;
    }
  }

  .blank-space {
    content: '';
    height: 1em;
  }

  @media (min-width: 1024px) {
    display: grid;
    padding: 0;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 24px;
  }

  .img-container {
    height: 102px;
    width: 102px;
  }
`;

export const ContentBox = styled.div`
  margin: 0 auto;

  @media (min-width: 600px) {
    width: 468px;
  }

  @media (min-width: 900px) {
    width: 560px;
  }
`;

export const ContentBoxWithNavBar = styled(ContentBox)<DefaultBoxWithNavBarProps>`
  margin-top: ${(props) =>
    props.isIos ? (props.isInternetConnected ? '108px' : '118px') : props.isInternetConnected ? '64px' : '94px'};
  padding: 0 16px calc(var(--tab-bar-height) + 30px) 16px;

  @media (min-width: 600px) {
    padding: 0;
  }
`;

type ContentBoxWorkWithShadowPropsType = {
  isIos: boolean;
  isInternetConnection: boolean;
};

export const ContentBoxWorkWithShadow = styled(ContentBox)<ContentBoxWorkWithShadowPropsType>`
  padding: 16px !important;
  margin-top: 0;
  @media (min-width: 900px) {
    width: 560px;
  }
  margin-bottom: 80px;
`;

export const ModalWindowBox = styled(IonModal)`
  --width: 100%;
  --height: 100%;
`;

export const StyledContainerIsIosIsInternetConnection = styled(ContentBox)<{
  isIos: boolean;
  isInternetConnection: boolean;
}>`
  padding: 16px;
`;

type StyledContainerPageWithHeaderProps = {
  isIos: boolean;
};

export const StyledContainerPageWithHeader = styled(IonPage)<StyledContainerPageWithHeaderProps>`
  &.overflow {
    overflow: auto !important;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  padding-top: ${(props) => (props.isIos ? 'calc(env(safe-area-inset-top) + 48px)' : '48px')};
  --ion-background-color: #fafafb;
  background-color: #fafafb;

  .spacing {
    height: 1em;
  }

  .spacing-5 {
    height: 5em;
  }

  .spacing-10 {
    height: 10em;
  }
`;

type ContainerPropsType = {
  isInternetConnected: boolean;
};

export const StyledContentContainer = styled(ContentBox)<ContainerPropsType>`
  margin-top: ${(props) => (props.isInternetConnected ? '24px' : '34px')};
  padding: 0 16px;

  @media (min-width: 600px) {
    padding: 0;
  }
`;
